






























































import 'vue-awesome/icons/check'
import 'vue-awesome/icons/pencil-alt'
require 'At.js-master/dist/css/jquery.atwho.css'
require 'At.js-master/dist/js/jquery.atwho.js'
require 'Caret.js-master/dist/jquery.caret.js'
require 'jquery-overlay-master/jquery.overlay.js'

Transaction = require 'models/transaction.coffee'

export default
  name: 'transaction_current_popover'
  components:
    tr_popover_header:    require('./popover_header.vue').default
    description:          require('./current_popover_description.vue').default
    category:             require('./current_popover_category.vue').default
    account_virtual:      require('./form_account_virtual.vue').default
    repeat_options:       require('./form_repeat_options.vue').default
    transfer_from_and_to: require('./current_popover_transfer_from_and_to.vue').default
    destroy_button:       require('./current_popover_destroy_button.vue').default
    save_button:          require('./current_popover_save_button.vue').default
    offline_bar:          require('components/inside/offline_bar.vue').default
  data: ->
    validateDescription = (rule, value, callback) =>
      value ||= ''
      sum = @transaction && @transaction.descriptionSum && @transaction.descriptionSum()
      if sum == 0 and !/\d/.test(value) and !_.isEmpty(value)
        callback new Error(@$t('description_must_include_amount'))
        return
      if sum < 0
        callback new Error(@$t('amount_can_not_be_negative'))
        return

      callback()
    return {
      transaction: null
      rules: {
        description: [ { validator: validateDescription } ]
        planned_repeat_end_date: [ { required: true, message: @$t('select_end_date') } ]
      }
      mode: 'enter' # or plan
      allow_mode_change: true
      formValid: false
      popper: undefined
    }
  watch:
    store_transaction:
      immediate: true
      deep: true
      handler: ->
        @transaction = _.clone @store_transaction
        return if not @has_transaction
        if @transaction.isConfirmed()
          @mode = 'enter'
          @allow_mode_change = false
        else
          @allow_mode_change = true
          if @transaction.date > hm_date.constants.today
            @mode = 'plan'
          else
            @mode = 'enter'
        @setDefaultEnvelope()
        if @transaction.isNew()
          @transaction.planned_repeat_days ||= 0
        @animateTabs()

    # Validations and remembering last used account
    transaction:
      immediate: true
      deep: true
      handler: ->
        @$nextTick =>
          return unless @$refs.form
          return unless @transaction
          @$refs.form.validate (valid) => @formValid = valid
        if @transaction.account_id
          @$store.state.ui.transactions.current.last_used_account_id = @transaction.account_id

    # Setting default envelope when switching mode tabs
    mode: -> @setDefaultEnvelope()
  computed:
    store_transaction:  -> @$store.state.ui.transactions.current.transaction
    has_transaction: ->
      result = !_.isEmpty(@transaction)
      if result == false
        @hide()
      return result
    modal_classes: -> 'modal animated faster fadeIn is-active tr-popover-modal' if HM.is_mobile
    classes: ->
      $transaction = $("#transaction-#{@transaction.id}")
      $transaction = $("#day-#{@transaction.date}") if $transaction.length == 0
      $transaction = $('#new_transaction_button') if $transaction.length == 0
      if $transaction.length != 0 && !HM.is_mobile
        @$nextTick (=>
          @popper.destroy() if @popper
          @popper = new Popper $transaction, $('#current_transaction_popover').addClass('fadeIn fast_animated'), { placement: 'right', positionFixed: true }
        )
      classes = "popover--#{@transaction.fullSubtype()}"
      classes += " el-popover el-popper tr-popover" # if !HM.is_mobile
      return classes

  methods:
    setDefaultEnvelope: ->
      # Only for new transactions
      return if not @has_transaction
      return if not @transaction.isNew()
      # don't overwrite envelope if it's set.
      # for HM envelope do overwrite it because it's the default one for new transactions
      return if @transaction.virtual_id && @transaction.virtual_id != -1
      @transaction.virtual_id = -1                    if @mode == 'enter'
      @transaction.virtual_id = @$store.getters.rs.id if @mode == 'plan'
    hide: ->
      @$store.dispatch('hideTransactionsPopovers')
      @popper.destroy() if @popper
    animateTabs: ->
      @$nextTick =>
        $(@$el).find('.tabs .is-active .icon').addClass('animated wobble')
        setTimeout (=> $(@$el).find('.icon').removeClass('animated wobble')), 500
    submitForm: -> @$refs.saveButton.save()
  destroyed: -> @hide()
  mounted: ->
    $(document).off('keydown.close_current_popover').on 'keydown.close_current_popover', (e) =>
      @hide() if e.keyCode == 27
